import React, { useEffect, useState } from "react";
import { Button, Pagination, Spin } from "antd";
import { StyledActiveUsersModal } from "./style";
import { useAppDispatch, useAppSelector } from "../../../../../../store/config";
import {
  getTrainingProgramActiveUsersStart,
  resetTrainingProgramActiveUsers,
} from "../../../../../../store/features/training-program/training-program-slice";
import { useTranslation } from "react-i18next";
import { PaginationType } from "../../../../../../interfaces/screens/fetch-params-types";
import { PAGE_SIZE } from "../../../../../../common/config";
import { StyledTable } from "../../../../../../components/common/styles/tableStyles";

const ActiveUsersModal = (props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  trainingProgramId: string;
  totalAccounts: number | null;
}) => {
  const { open, setOpen, trainingProgramId, totalAccounts } = props;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [pagination, setPagination] = useState<PaginationType>({
    page: 0,
    limit: PAGE_SIZE,
    skip: 0,
  });

  const { activeUsers, loading } = useAppSelector(
    (state) => state.trainingProgram
  );

  useEffect(() => {
    if (open && trainingProgramId)
      dispatch(
        getTrainingProgramActiveUsersStart({
          trainingProgramId,
          pagination,
        })
      );
  }, [open, trainingProgramId, pagination]);

  useEffect(() => {
    if (!open) dispatch(resetTrainingProgramActiveUsers());
  }, [open]);

  const handleCancel = () => {
    setOpen(false);
  };

  const columns = [
    {
      title: t("Full Name"),
      dataIndex: "fullName",
      key: "fullName",
      render: (text: string, record: any) => {
        return <span>{`${record.firstName} ${record.lastName}`}</span>;
      },
    },
    {
      title: t("Week in Program"),
      dataIndex: "currentWeek",
      key: "currentWeek",
      render: (text: string, record: any) => {
        return <span>{`${record.currentWeek || "-"}`}</span>;
      },
    },
    {
      title: t("Email"),
      dataIndex: "emailLower",
      key: "emailLower",
    },
  ];

  const onPaginationChange = (page: number) => {
    setPagination({ ...pagination, page, skip: PAGE_SIZE * (page - 1) });
  };

  return (
    <>
      <StyledActiveUsersModal
        title={t("Active Users")}
        open={open}
        footer={[
          <Button type="primary" key="back" onClick={handleCancel}>
            {t("Close")}
          </Button>,
        ]}
        onCancel={handleCancel}
        centered
        width={650}
      >
        <Spin spinning={loading}>
          <StyledTable
            columns={columns}
            dataSource={activeUsers}
            pagination={false}
            locale={{ emptyText: t("No results") }}
            rowKey="_id"
          />
          <Pagination
            current={pagination.page}
            pageSize={PAGE_SIZE}
            total={totalAccounts || 0}
            align="center"
            hideOnSinglePage
            onChange={onPaginationChange}
            showSizeChanger={false}
            style={{ direction: "ltr", marginTop: "60px" }}
          />
        </Spin>
      </StyledActiveUsersModal>
    </>
  );
};

export default ActiveUsersModal;
